var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8C18.287 8 14.726 9.475 12.1005 12.1005C9.475 14.726 8 18.287 8 22C8 25.713 9.475 29.274 12.1005 31.8995C14.726 34.525 18.287 36 22 36C25.713 36 29.274 34.525 31.8995 31.8995C34.525 29.274 36 25.713 36 22C36 18.287 34.525 14.726 31.8995 12.1005C29.274 9.475 25.713 8 22 8ZM20.708 26.708L29.708 17.708L28.292 16.292L20 24.586L15.708 20.292L14.292 21.708L19.292 26.708C19.3849 26.8011 19.4952 26.875 19.6167 26.9254C19.7382 26.9758 19.8685 27.0018 20 27.0018C20.1315 27.0018 20.2618 26.9758 20.3833 26.9254C20.5048 26.875 20.6151 26.8011 20.708 26.708Z",
    fill: "#20C997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d62e8c4d2e670ec845bc893fcc360bce.svg";
export { ForwardRef as ReactComponent };